import axios from "axios";
import configData from "../config/config";
import { configKeys, userKeys } from "./Constant";

// Method use to make api request to aws
const getConfigurations = async (pageSize, pageToken = {}, searchString = "", filterOption = "", idToken = []) => {
  // TODO: Logging framework to be added in future.
  const url = `${configData.API_URL}/configs/search`;
  const selectedFilterOption = Array.isArray(filterOption)
    ? filterOption
    : typeof filterOption === "string" && filterOption
    ? [filterOption]
    : [];

  let configFilters = [];
  let userFilters = [];

  // To send email ,config filter option in payload if no filter option is selected
  if (searchString && selectedFilterOption?.length === 0) {
    configFilters = [...configKeys];
  } else {
    configFilters = selectedFilterOption.filter((key) => configKeys.includes(key));
    userFilters = selectedFilterOption.filter((key) => userKeys.includes(key));
  }
  const body = {
    ...(searchString && configFilters.length > 0 && { configFilterOption: configFilters.join(",") }),
    ...(searchString && userFilters.length > 0 && { userFilterOption: userFilters.join(",") }),
    ...(searchString && { searchString }),
    ...(pageToken && Object.keys(pageToken).length > 0 && { lastEvaluatedKey: pageToken }),
    ...(searchString && userFilters.length > 0 && idToken.length > 0 && { remainingUserIds: idToken }),
    pageSize,
  };

  const res = await axios({
    method: "POST",
    url,
    data: body,
  });
  return res;
};

const getReportData = async (configId) => {
  const url = `${configData.API_URL}/configs/${configId}/calculate`;
  const res = await axios({
    method: "POST",
    url,
  });
  return res;
};
const getSystemTypes = async () => {
  const url = `${configData.API_URL}/standards`;
  const res = await axios({
    method: "GET",
    url,
  });
  return res;
};

// used for get system types from the localstorage
const getStandardListFromLocalStorage = () => {
  if (localStorage.key("standardList")) {
    return JSON.parse(localStorage.getItem("standardList"));
  }
  return null;
};

// used for get system types from the localstorage
const getFooterListFromLocalStorage = () => {
  if (localStorage.key("footerList")) {
    return JSON.parse(localStorage.getItem("footerList"));
  }
  return null;
};

// Statistics API
const getStatisticData = async (startDate, endDate) => {
  let url = `${configData.API_URL}/users/stats`;
  if (startDate) {
    url = `${configData.API_URL}/users/stats?fromDate=${startDate}&toDate=${endDate}`;
  }
  const res = await axios({
    method: "GET",
    url,
  });
  return res;
};
const ConfigService = {
  getConfigurations,
  getReportData,
  getSystemTypes,
  getStandardListFromLocalStorage,
  getFooterListFromLocalStorage,
  getStatisticData,
};

export default ConfigService;
